import apiClient from './apiClient';

export const validateAccess = async () => {
  const response = await apiClient.post('/auth/login');
  return response.data;
};
